export type ISigSyncEventType =
  | 'ASSIGNED'
  | 'CANCELED'
  | 'CHECKED_IN'
  | 'CONFIRMED'
  | 'DOCUMENTS_UPLOADED'
  | 'DOCUMENTS_DOWNLOADED'
  | 'REQUESTED'
  | 'SCAN_UPLOADED'
  | 'SIGNED';

const labelsByEventType = {
  ASSIGNED: 'Assigned',
  CHECKED_IN: 'Checked In',
  CONFIRMED: 'Checked In',
  DOCUMENTS_UPLOADED: 'Docs Uploaded',
  DOCUMENTS_DOWNLOADED: 'Docs Downloaded',
  NOT_SIGNED: 'Did Not Sign',
  REQUESTED: 'Requested',
  SCAN_UPLOADED: 'Scans Uploaded',
  SIGNED: 'Signed',
  CANCELED: 'Canceled',
};

export const subLabelColorByEventType = {
  SCAN_UPLOADED: 'bg-green-100 text-green-800',
  CANCELED: 'bg-red-100 text-red-800',
  NOT_SIGNED: 'bg-red-100 text-red-800',
};

export const getSigSyncEventTypeLabel = (eventType: ISigSyncEventType): string => {
  return labelsByEventType[eventType];
};
